/**
 * Polyfills for the browsers of the build targets ("browserslist" in package.json; Safari and iOS matter most).
 * Imported first in src/index.js, before any application code.
 *
 * The build (react-scripts 4) transpiles the syntax for the targets, but does not add the built-in objects
 * and methods: a newer API the targets lack is polyfilled here, by its own core-js module (only the API used,
 * not all of core-js) or by a small polyfill of a DOM method. Each polyfill only fills a missing API.
 * See the "Browser support and polyfills" section of README.md.
 */

// String.prototype.replaceAll: Safari / iOS 13.1
import 'core-js/stable/string/replace-all';
// Promise.allSettled: Safari / iOS 13
import 'core-js/stable/promise/all-settled';

import { polyfillReplaceChildren } from './replace-children';

// Element.prototype.replaceChildren: Safari / iOS 14
polyfillReplaceChildren();
